import React, { useEffect } from 'react';
import { useRouteMatch } from "react-router-dom";

import './functioncontainer.scss';

import { FunctionCard } from './functionCard';
import { useSelector } from 'react-redux';


export const FunctionContainer = ({ functionData, deleteproduct, setSelectedTab, handleFunctionStatus }: any) => {
  const match: any = useRouteMatch();
  const currentUserId = useSelector((state: any) => state.user.data.user.id)

  useEffect(() => {
    const pathSegments = match.path.split("/");
    if (pathSegments.length) {
      const selectedTab = pathSegments[pathSegments.length - 1];
      setSelectedTab(selectedTab);
    }
  }, [match.path, setSelectedTab]);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-7 function-container">
      {functionData.map((data: any) => {
        return <FunctionCard key={data.id} handleFunctionStatus={handleFunctionStatus} functionData={data} deleteproduct={deleteproduct} editAccess={data.created_by.id === currentUserId} />;
      })}
    </div>
  )
};

